import { render, staticRenderFns } from "./ApprovalsList.vue?vue&type=template&id=93fa407e&scoped=true"
import script from "./ApprovalsList.vue?vue&type=script&lang=js"
export * from "./ApprovalsList.vue?vue&type=script&lang=js"
import style0 from "./ApprovalsList.vue?vue&type=style&index=0&id=93fa407e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fa407e",
  null
  
)

export default component.exports